export default __webpack_public_path__ + "static/media/row-crops.e8d309e4.svg";